if (!customElements.get('product-audio-player')) {
  customElements.define('product-audio-player', class ProductAudioPlayer extends HTMLElement {
    connectedCallback() {
      this.audioEl = this.querySelector('.audio-element');
      this.btn = this.querySelector('.audio-play-btn');
      this.progressEl = this.querySelector('.audio-progress');
      this.progressBar = this.querySelector('.audio-progress-bar');
      this.timeEl = this.querySelector('.audio-time');
      this.playIcon = this.querySelector('.icon-play');
      this.pauseIcon = this.querySelector('.icon-pause');

      if (!this.audioEl || !this.btn) return;

      this._onBtnClick = () => this.audioEl.paused ? this.audioEl.play() : this.audioEl.pause();
      this._onMetadata = () => { this.timeEl.textContent = this._fmt(this.audioEl.duration); };
      this._onTimeUpdate = () => {
        const pct = this.audioEl.duration ? (this.audioEl.currentTime / this.audioEl.duration) * 100 : 0;
        this.progressBar.style.width = pct + '%';
        this.timeEl.textContent = this._fmt(this.audioEl.currentTime);
      };
      this._onPlay = () => this._syncBtn();
      this._onPause = () => this._syncBtn();
      this._onEnded = () => {
        this._syncBtn();
        this.progressBar.style.width = '0%';
        this.timeEl.textContent = this._fmt(this.audioEl.duration);
      };
      this._onProgressClick = (e) => {
        if (!this.audioEl.duration) return;
        const rect = this.progressEl.getBoundingClientRect();
        this.audioEl.currentTime = ((e.clientX - rect.left) / rect.width) * this.audioEl.duration;
      };

      this.btn.addEventListener('click', this._onBtnClick);
      this.audioEl.addEventListener('loadedmetadata', this._onMetadata);
      this.audioEl.addEventListener('timeupdate', this._onTimeUpdate);
      this.audioEl.addEventListener('play', this._onPlay);
      this.audioEl.addEventListener('pause', this._onPause);
      this.audioEl.addEventListener('ended', this._onEnded);
      this.progressEl.addEventListener('click', this._onProgressClick);

      this._syncBtn();
    }

    disconnectedCallback() {
      this.btn?.removeEventListener('click', this._onBtnClick);
      this.audioEl?.removeEventListener('loadedmetadata', this._onMetadata);
      this.audioEl?.removeEventListener('timeupdate', this._onTimeUpdate);
      this.audioEl?.removeEventListener('play', this._onPlay);
      this.audioEl?.removeEventListener('pause', this._onPause);
      this.audioEl?.removeEventListener('ended', this._onEnded);
      this.progressEl?.removeEventListener('click', this._onProgressClick);
    }

    _syncBtn() {
      const paused = this.audioEl.paused;
      this.playIcon.hidden = !paused;
      this.pauseIcon.hidden = paused;
      this.btn.setAttribute('aria-label', paused ? this.btn.dataset.playLabel : this.btn.dataset.pauseLabel);
    }

    _fmt(s) {
      if (isNaN(s)) return '0:00';
      return `${Math.floor(s / 60)}:${String(Math.floor(s % 60)).padStart(2, '0')}`;
    }
  });
}
